module.exports = __webpack_public_path__ + "img/STC.a5c06ff9.png";